<template>
  <div class="dialog-call">
    <div
      v-if="currentLeadInfo.campaignName"
      class="dialog-call__header"
    >
      {{ currentLeadInfo.campaignName }}
    </div>
    <div class="flex flex justify-center w-full gap-4">
      <div
        class="dialog-call__info"
        v-show="!remoteStreamHasVideo"
      >
        <div>
          <!--         <Avatar
          color="secondary"
          :size="160"
          :initials="initials"
          :email="email"
        /> -->
          <img
            class="rounded-full"
            width="130"
            :alt="'Profile'"
            :src="require('@/assets/profile_dialer.png')"
          >
        </div>
        <div class="dialog-call__details-container">
          <template>
            <p class="dialog-call__name dialog-call__details">
              {{ currentLeadInfo.name }}
            </p>
            <p
              class="dialog-call__details"
            >
              {{ currentLeadInfo.country }}
            </p>
          </template>
          <p class="dialog-call__state">
            {{ callState }}
          </p>
        </div>
      </div>
      <div
        v-if="currentLeadInfo.metadata"
        class="dialog-call__metadata"
      >
        <div
          class="dialog-call__metadata-info-container"
          v-for="(value, key, index) in currentLeadInfo.metadata"
          :key="key"
        >
          <template v-if="index <= 10">
            <span
              class="dialog-call__metadata-header"
              :title="key"
            >{{ ( key.length > 15) ? key.slice(0, 15) + '...' : key }} :</span>
            <span
              class="break-all"
              :title="value"
            >{{ ( value.length > 30) ? value.slice(0, 30) + '...' : value }}</span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  props: {
    initials: {
      type: String,
      default: '',
      required: true,
    },
    email: {
      type: String,
      default: '',
      required: true,
    },
    name: {
      type: String,
      default: '',
      required: true,
    },
  },
  computed: {
    ...mapState('leadLists', ['currentLeadInfo']),
    ...mapGetters('webrtc', [
      'remoteStreamHasVideo',
      'isCallInitiating',
      'isCallIncoming',
      'isCallOutgoing',
      'isCallAccepted',
      'isCallProgress',
    ]),
    callState() {
      if (this.isCallInitiating) {
        if (this.isCallIncoming) {
          return this.$t('modal.incoming')
        } else if (this.isCallOutgoing) {
          return this.$t('modal.calling')
        } else {
          return this.$t('modal.unknown')
        }
      } else if (this.isCallAccepted) {
        return this.$t('modal.accepted')
      } else if (this.isCallProgress) {
        return this.$t('modal.progress')
      } else {
        return this.$t('modal.hangup')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-call {
 @apply flex flex-col w-full;
}

.dialog-call__info {
  @apply flex flex-col m-0 my-4 justify-center items-center w-1/2 z-20;

  > .col {
    @apply p-0 flex justify-center flex-grow-0;
  }
}

.dialog-call__details-container {
  flex-basis: auto;

  /* autoprefixer: off */
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  -moz-line-clamp: 3;
  -ms-line-clamp: 3;
  -o-line-clamp: 3;

  @apply flex-none my-3 mx-0 overflow-hidden overflow-ellipsis;
}

.dialog-call__details {
  @apply text-lg font-bold m-0 px-5 text-center break-all;
}

.dialog-call__name {
  @apply text-2xl;
}

.dialog-call__state {
  @apply text-sm text-blue text-center;
}

.dialog-call__metadata {
  @apply flex flex-col gap-4 my-3 px-6 w-1/2 overflow-ellipsis whitespace-normal text-sm my-10;
}

.dialog-call__metadata-header {
  @apply font-bold break-normal;
}

.dialog-call__metadata-info-container {
  @apply flex justify-between gap-4;
}

.dialog-call__header {
  @apply w-full text-lg m-0 px-5 py-2 text-white;
  background-color: var(--v-surface-base);
}

</style>
